const DEFAULT_REQUIRED_FILES = [{ key: 'file', label: 'File', required: true }];

const sanitizeRequiredFiles = (requiredFiles = []) => {
	const files = Array.isArray(requiredFiles) ? requiredFiles : [];

	return files
		.map((item) => ({
			key: item?.key ? String(item.key).trim() : '',
			label: item?.label ? String(item.label).trim() : '',
			required: item?.required !== false,
		}))
		.filter(item => item.key);
};

const normalizeRequiredFiles = (settings = {}) => {
	const normalized = sanitizeRequiredFiles(settings?.requiredFiles || []);
	return normalized.length ? normalized : DEFAULT_REQUIRED_FILES;
};

export {
	DEFAULT_REQUIRED_FILES,
	sanitizeRequiredFiles,
	normalizeRequiredFiles,
};
